<form [formGroup]="webhookForm">
    <!-- <mat-form-field *ngIf="webhook._id" appearance="standard">
        <mat-label>Integration ID</mat-label>
        <input type="text" [value]="webhook._id" matInput disabled />
    </mat-form-field> -->
    <mat-form-field *ngIf="webhook.secret" appearance="standard">
        <mat-label>Secret</mat-label>
        <input type="text" [value]="webhook.secret" matInput readonly />
        <button mat-icon-button matSuffix [cdkCopyToClipboard]="webhook.secret" (click)="copied()" matTooltip="Copy to clipboard">
            <mat-icon>file_copy</mat-icon>
        </button>
    </mat-form-field>
    <mat-form-field appearance="standard">
        <mat-label>Target URL</mat-label>
        <input type="url" formControlName="target" matInput placeholder="Target URL" required />
    </mat-form-field>
</form>